import { useState } from "react";
import { IoCloseOutline, IoCloudUploadSharp } from "react-icons/io5";
import * as D from "assets/iconsSVG/documentIcon";
import { RiDeleteBin6Line } from "react-icons/ri";
import * as MaterialUI from "@material-ui/core";
import { useComprovanteAto } from "services/api/AppWeb_Oportunidade/post-comprovante-ato";
import { toast } from "react-toastify";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
  /**
   * Quando `true`, a modal opera em modo de substituição do comprovante já
   * enviado (acionada pelo histórico) e apenas ajusta os textos — o envio
   * continua usando o mesmo endpoint.
   */
  isReplace?: boolean;
}

const ModalComprovanteAto = (data: Data) => {
  const [uploadedFile, setUploadedFile] = useState<any>(null);

  const { mutate: mutateComprovanteAto, isLoading: isLoadingComprovanteAto } =
    useComprovanteAto();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setUploadedFile(e.target.files[0]);
    }
  };

  // const calculateBase64Size = (originalSize: number) => {
  //   return parseFloat(((originalSize * 4) / 3 / 1024).toFixed(2));
  // };

  const handleSendFile = () => {
    if (uploadedFile && uploadedFile.size <= 30 * 1024 * 1024) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target?.result;
        mutateComprovanteAto(
          {
            idOportunidade: data.dataDetalheOportunidade?.idOportunidade,
            extensaoArquivo: uploadedFile.name.split(".").pop() as string,
            // tamanhoArquivo: calculateBase64Size(uploadedFile.size),
            base64: (base64 as string).split(",").pop() as string,
            isReplace: data.isReplace,
          },
          {
            onSuccess: () => {
              data.refetchDetalheOportunidade();
              data.refetchHistorico();
              data.onClose();
            },
          }
        );
      };
      reader.readAsDataURL(uploadedFile);
    } else if (uploadedFile?.size > 30 * 1024 * 1024) {
      toast.error("O arquivo deve ter no máximo 30MB");
    }
  };

  const handleRemoveFile = () => {
    setUploadedFile(null);
  };

  const textoBotaoEnvio = data.isReplace ? "Substituir" : "Enviar";

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <D.DocumentIcon />
            <S.TextTitle>
              {data.isReplace
                ? "Trocar Comprovante do Ato"
                : "Upload de Documentos"}
            </S.TextTitle>
          </div>
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={8} />
      <S.Body>
        {!uploadedFile ? (
          <label htmlFor="file-upload">
            <S.ContentRowCutted>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>
                {data.isReplace
                  ? "Carregar novo comprovante"
                  : "Carregar novo Anexo"}
              </S.TextDescription>
            </S.ContentRowCutted>
            <input
              id="file-upload"
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>
        ) : (
          <>
            <S.ContentDocument>
              <S.TextUpload>Documento</S.TextUpload>
            </S.ContentDocument>
            <S.SpaceY space={8} />
            <S.ContentInfoDocument>
              <S.TextUpload>{uploadedFile.name}</S.TextUpload>
              <S.DeleteButton onClick={handleRemoveFile}>
                <RiDeleteBin6Line size={24} color="#ff4d4f" />
              </S.DeleteButton>
            </S.ContentInfoDocument>
            <S.SpaceY space={8} />
            <S.ContentRowCuttedNoAction>
              <IoCloudUploadSharp size={24} color="#999999" />
              <S.TextDescription>Você já carregou um anexo</S.TextDescription>
            </S.ContentRowCuttedNoAction>
          </>
        )}
        <S.SpaceY space={32} />
        <S.SaveButton
          onClick={() => {
            handleSendFile();
          }}
          disabled={!uploadedFile || isLoadingComprovanteAto}
        >
          {isLoadingComprovanteAto ? (
            <MaterialUI.CircularProgress
              size={22}
              style={{ color: "#ffffff" }}
            />
          ) : (
            textoBotaoEnvio
          )}
        </S.SaveButton>
      </S.Body>
    </S.Content>
  );
};

export default ModalComprovanteAto;
